<div class="card panel-default hs-main-panel hs-layermanager-card" [hidden]="(isVisible$ | async) === false">
    <hs-panel-header name="layermanager" [title]="'PANEL_HEADER.LM' | translateHs">
        <extra-buttons class="d-flex align-items-center">
            <div class="btn-group" ngbDropdown placement="left-top" display="dynamic">
                <button type="button" class="border-0 but-title-sm hs-extra-buttons"
                    (click)="physicalLayerListEnabled = !physicalLayerListEnabled"
                    [title]="'LAYERMANAGER.enablePhysicalLayerList' | translateHs">
                    <i class="glyphicon icon-layerorder"></i>
                </button>
                <button ngbDropdownToggle class="but-title-sm  hs-extra-buttons me-1" type="button"><i
                        class="icon-menu"></i></button>
                <div ngbDropdownMenu>
                    <a class="dropdown-item" (click)="removeMultipleLayers()">
                        <i class="glyphicon icon-trash hs-extra-button"></i>&nbsp;{{'DRAW.removeMultipleLayers'
                        | translateHs }}
                    </a>
                    <a class="dropdown-item" (click)="removeAllLayers()">
                        <i
                            class="glyphicon icon-trash hs-extra-button"></i>&nbsp;{{'LAYERMANAGER.dialogRemoveAll.removeAllAdded'
                        |
                        translateHs }}
                    </a>
                    <a class="dropdown-item" (click)="hsCore.resetMap()">
                        <i class="glyphicon icon-fatredo hs-extra-button"></i>&nbsp;{{'LAYERMANAGER.resetMap' |
                        translateHs }}
                    </a>
                    <a class="dropdown-item"
                        *ngIf="hsLayerManagerService.data.layers?.length > 0 && !physicalLayerListEnabled"
                        (click)="toggleVisibilityForAll()">
                        <i class="glyphicon" [ngClass]="allLayersVisible ? 'hs-checkmark' : 'hs-uncheckmark'"></i>
                        {{'LAYERMANAGER.toggleAllLayerVisibility'|translateHs}}
                    </a>
                </div>
            </div>
        </extra-buttons>
    </hs-panel-header>
    <div class="card-body hs-lm-panel">
        <div class="nav nav-pills" [hidden]="!hasBoxImages()">
            <div *ngFor="let box of hsLayerManagerService.data.box_layers"
                class="col-xs-2 col-md-2 list-group-item-primary" style="padding-right: 2px; padding-left: 2px;">
                <a [ngClass]="{ 'thumbnail': true, 'alert-info': getActive(box)}" [title]="getTitle(box)"
                    (click)="activateTheme(box)">
                    <!-- TODO: Remove function call from template -->
                    <img [src]="box.thumbnail" [alt]="getTitle(box)"><!-- TODO: Remove function call from template -->
                </a>
            </div>
        </div>
        <div><input type="text" class="form-control hs-filter" [placeholder]="'COMMON.filter' | translateHs"
                [(ngModel)]="hsLayerManagerService.data.filter" [ngModelOptions]="{standalone: true}"
                (input)="filterLayerTitles()">
        </div>

        <ul *ngIf="!hsLayoutService.componentEnabled('basemapGallery')" class="list-group hs-lm-baselayerlist">
            <!-- TODO: Remove function call from template -->
            <li class="list-group-item hs-lm-item hs-lm-header clearfix list-group-item-primary">
                <div class="d-flex">
                    <div class="p-0 flex-grow-1 hs-lm-item-title">
                        <span class="align-middle" style="line-height: 2em;">{{'LAYERMANAGER.baselayers' |
                            translateHs}}</span>
                    </div>
                    <div class="p-0">
                        <button type="button" class="btn btn-sm hs-btn-baselayers" (click)="changeBaseLayerVisibility()"
                            [ngClass]="hsLayerManagerService.data.baselayersVisible ? 'hs-checkmark' : 'hs-uncheckmark'"></button>
                    </div>
                </div>
            </li>
            <li class="list-group-item hs-lm-item my-2 my-md-0"
                *ngFor="let layer of hsLayerManagerService.data.baselayers | filter:baselayerFilter"
                [ngClass]="{'hs-lm-deactivated-layer': !layer.visible || !layer.active}" [id]="layer.idString()">
                <div class="d-flex">
                    <div class="p-0">
                        <button type="button" class="btn btn-sm btn-light hs-lm-item-visibility"
                            (click)="changeBaseLayerVisibility($event, layer);"
                            [ngClass]="(hsLayerManagerService.data.baselayersVisible && layer.visible) ? 'hs-checkmark' : 'hs-uncheckmark'"></button>
                    </div>
                    <ng-template #abstractTooltip>
                        <span [innerHtml]="hsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract)"></span>
                    </ng-template>
                    <div class="align-items-center p-0 flex-grow-1 hs-lm-item-title" style="cursor:context-menu"
                        [ngClass]="{'fw-bold': layer.active, 'text-muted' : layer.grayed}"
                        [ngbTooltip]="layer.abstract ? abstractTooltip : ''" [closeDelay]="layerTooltipDelay">
                        {{layer.title | translateHs : {module: 'LAYERS'} }}
                    </div>
                    <div class="ps-1 info_btn" style="cursor: pointer;">
                        <span class="icon-settingsthree-gears text-secondary"
                            (click)="hsLayerManagerService.toggleLayerEditor(layer,'settings','sublayers')"
                            [title]="'COMMON.info' | translateHs" data-toggle="tooltip" data-container="body"
                            data-placement="auto"></span>
                    </div>
                </div>
                <ngb-progressbar type="secondary" *ngIf="layer.loadProgress?.loadTotal > 0"
                    [value]="layer.loadProgress.percents" height="2px"></ngb-progressbar>
            </li>
        </ul>

        <ul class="list-group hs-lm-baselayerlist" [hidden]="!(hsLayerManagerService.data.terrainlayers.length > 0)">
            <li class="list-group-item hs-lm-item hs-lm-header clearfix list-group-item-primary">
                <div class="d-flex">
                    <div class="p-0 flex-grow-1 hs-lm-item-title">
                        <span class="align-middle" style="line-height: 2em;">{{ 'LAYERMANAGER.terrains' |
                            translateHs}}</span>
                    </div>
                </div>
            </li>
            <li class="list-group-item hs-lm-item"
                *ngFor="let layer of hsLayerManagerService.data.terrainlayers | filter:baselayerFilter"
                (click)="changeTerrainLayerVisibility($event, layer)" (mouseenter)="hovering=true"
                (mouseleave)="hovering=false" [ngClass]="{'hovering': (hovering && !layer.active)}">
                <div class="d-flex ">
                    <!-- <div class="p-0" ng-show="layer.active || hovering"
                        ng-style="hovering && !layer.active && {'opacity':'0.5'}">
                        <button class="btn btn-sm btn-link hs-lm-baseitem-visibility"><i
                                class="icon-globe"></i></button>
                    </div> -->
                    <div class="p-0">
                        <button type="button" class="btn btn-sm btn-light hs-lm-item-visibility"
                            [ngClass]="(hsLayerManagerService.data.baselayersVisible && layer.visible) ? 'hs-checkmark' : 'hs-uncheckmark'"></button>
                    </div>
                    <ng-template #abstractTooltip>
                        <span [innerHtml]="hsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract)"></span>
                    </ng-template>
                    <div class="align-items-center p-0 flex-grow-1 hs-lm-item-title"
                        [ngClass]="{'fw-bold': layer.active, 'text-muted': layer.grayed}"
                        [ngbTooltip]="layer.abstract ? abstractTooltip : ''" [closeDelay]="layerTooltipDelay">
                        <!-- TODO: Remove function call from template -->
                        {{layer.title | translateHs : {module: 'LAYERS'} }}
                    </div>
                </div>
            </li>
        </ul>
        <ul class="list-group hs-lm-mapcontentlist">
            <!-- TODO: Remove function call from template -->
            <li *ngIf="!hsLayoutService.componentEnabled('basemapGallery')"
                class="hs-lm-header hs-lm-item list-group-item-primary hs-lm-map-content-header list-group-item"
                style="margin-bottom: 0.2em;">
                <span class="align-middle" style="line-height: 2em;">{{ 'LAYERMANAGER.mapContent' | translateHs}}</span>
            </li>
            <ul class="list-group hs-lm-layerlist mb-1"
                *ngFor="let value of hsLayerManagerService.data.folders.sub_folders"
                [hidden]="physicalLayerListEnabled">
                <li class="list-group-item hs-lm-layerlist-header list-group-item-primary"
                    *ngIf="hsLayerManagerService.data.folders.sub_folders.length > 1"
                    (click)="value.visible = !value.visible">
                    <span>{{value.name | translateHs : {module: 'LAYERMANAGER'} }}&nbsp;</span>
                    <span class="glyphicon"
                        [ngClass]="value.visible ? 'icon-chevron-right' : 'icon-chevron-down'"></span>
                </li>
                <div [hidden]="!value.visible">
                    <li [hidden]="!(value.sub_folders.length > 0)">
                        <hs-layer-manager-folder [folder]="value"></hs-layer-manager-folder>
                    </li>
                    <li>
                        <hs-layermanager-layer-list [folder]="value"></hs-layermanager-layer-list>
                    </li>
                </div>
            </ul>
            <ul class="list-group hs-lm-layerlist mb-1" [hidden]="!physicalLayerListEnabled">
                <li>
                    <hs-layermanager-physical-layer-list></hs-layermanager-physical-layer-list>
                </li>
            </ul>
            <!--
        <div class="btn-group" data-toggle="buttons">
            <label class="btn btn-secondary active">
            <input type="radio" name="options" id="option1" checked> Logical order
            </label>
            <label class="btn btn-secondary">
            <input type="radio" name="options" id="option2"> Physical order
            </label>
        </div> -->
        </ul>
        <hs-layer-editor [current-layer]="hsLayerManagerService.currentLayer" #layerEditor
            [hidden]="!hsLayerManagerService.currentLayer" class="hs-layerpanel w-100">
        </hs-layer-editor>
    </div>
</div>